/** Every key playback keeps in `env.store`. All of it is the signed-in account's. */
export const PLAYBACK_STORAGE_KEYS = {
    volume: 'playbackVolume',
    playbackRate: 'playbackRate',
    audiobookPlaybackRate: 'audiobookPlaybackRate',
    streamingSettings: 'streamingQualitySettings',
    queueRestore: 'queueRestore.v1',
} as const
